"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signUserOperation = void 0;
const utils_1 = require("../../../utils/index.js");
const signMessage_1 = require("./signMessage.js");
const signUserOperation = async (client, { account, userOperation, entryPoint: entryPointAddress, chainId }) => {
    return (0, signMessage_1.signMessage)(client, {
        account: account,
        message: {
            raw: (0, utils_1.getUserOperationHash)({
                userOperation,
                entryPoint: entryPointAddress,
                chainId: chainId
            })
        }
    });
};
exports.signUserOperation = signUserOperation;
//# sourceMappingURL=signUserOperation.js.map